export default "assets/images/icons/globe-c876f405.svg";